import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { style: {"font-size":"20px","margin-left":"5px"} }
const _hoisted_3 = { style: {"color":"red","font-size":"16px","margin-left":"5px"} }
const _hoisted_4 = { class: "tb" }
const _hoisted_5 = { class: "td-cell" }
const _hoisted_6 = { class: "td-cell" }
const _hoisted_7 = { class: "td-cell" }
const _hoisted_8 = { class: "td-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_HistoryViewDialog = _resolveComponent("HistoryViewDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_space, { wrap: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataRef.list, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_card, {
            style: {"min-width":"320px","max-width":"640px"},
            key: index
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(item.name) + " ", 1),
                  _createElementVNode("span", {
                    style: _normalizeStyle({color:item.profit>0?'red':'green'})
                  }, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.formatRate(item.profitRate)), 1),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatUsdtPlus(item.profit)), 1)
                  ], 4)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _cache[1] || (_cache[1] = _createTextVNode("资产 ")),
                _createVNode(_component_el_button, {
                  link: "",
                  onClick: ($event: any) => (_ctx.openHistoryDialog(item.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("资产记录")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createVNode(_component_el_descriptions, {
                direction: "vertical",
                column: 4,
                size: 'default',
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, {
                    label: "BTC",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatCoin(item.btcBalance)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "ETH",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatCoin(item.ethBalance)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "USDT",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatUsdt(item.usdtBalance)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "合计",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatUsdt(item.usdValue)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "本金",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatUsdt(item.costUsdt)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "增长",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({color:item.profit>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatUsdtPlus(item.profit)), 5)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "增长率",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({color:item.profit>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatRate(item.profitRate)), 5)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "年化",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({color:item.profit>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatRate(item.profitYear)), 5)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _cache[2] || (_cache[2] = _createElementVNode("div", null, "仓位", -1)),
              _createVNode(_component_el_descriptions, {
                direction: "vertical",
                column: 4,
                size: 'default',
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, {
                    label: "BTC仓位",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatCoin(item.btcSell)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "利润",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({color:item.btcUnrealized>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatCoin(item.btcUnrealized)), 5)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "ETH仓位",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatCoin(item.ethSell)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_descriptions_item, {
                    label: "利润",
                    "label-align": "center"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({color:item.ethUnrealized>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatCoin(item.ethUnrealized)), 5)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        (_ctx.dataRef.spot)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 0,
              style: {"min-width":"300px","max-width":"640px"}
            }, {
              header: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "10号BTC")
                ], -1)
              ])),
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createElementVNode("div", null, "资产", -1)),
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("tbody", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "td-head" }, "币种"),
                      _createElementVNode("th", { class: "td-head" }, "BTC"),
                      _createElementVNode("th", { class: "td-head" }, "USDT")
                    ], -1)),
                    _createElementVNode("tr", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("th", { class: "td-head" }, "本金", -1)),
                      _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.formatCoin(_ctx.dataRef.spot.costBtc)), 1),
                      _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.formatUsdt(_ctx.dataRef.spot.costUsdt)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("th", { class: "td-head" }, "余额", -1)),
                      _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.formatCoin(_ctx.dataRef.spot.btcBalance)), 1),
                      _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatUsdt(_ctx.dataRef.spot.usdtBalance)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("th", { class: "td-head" }, "利润", -1)),
                      _createElementVNode("td", {
                        class: "td-cell",
                        style: _normalizeStyle({color:(_ctx.dataRef.spot.btcBalance-_ctx.dataRef.spot.costBtc)>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatCoinPlus(_ctx.dataRef.spot.btcBalance-_ctx.dataRef.spot.costBtc)), 5),
                      _createElementVNode("td", {
                        class: "td-cell",
                        style: _normalizeStyle({color:(_ctx.dataRef.spot.usdtBalance-_ctx.dataRef.spot.costUsdt)>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatUsdt(_ctx.dataRef.spot.usdtBalance-_ctx.dataRef.spot.costUsdt)), 5)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("th", { class: "td-head" }, "利润比", -1)),
                      _createElementVNode("td", {
                        class: "td-cell",
                        style: _normalizeStyle({color:(_ctx.dataRef.spot.btcBalance-_ctx.dataRef.spot.costBtc)>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatRate((_ctx.dataRef.spot.btcBalance-_ctx.dataRef.spot.costBtc)/_ctx.dataRef.spot.costBtc)), 5),
                      _createElementVNode("td", {
                        class: "td-cell",
                        style: _normalizeStyle({color:(_ctx.dataRef.spot.usdtBalance-_ctx.dataRef.spot.costUsdt)>0?'red':'green'})
                      }, _toDisplayString(_ctx.formatRate((_ctx.dataRef.spot.usdtBalance-_ctx.dataRef.spot.costUsdt)/_ctx.dataRef.spot.costUsdt)), 5)
                    ])
                  ])
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"height":"62px","display":"block"} }, null, -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_HistoryViewDialog, { ref: "historyViewDialogRef" }, null, 512)
  ], 64))
}